import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import businessOnboardingApi from '../../api/businessOnboarding';

export default function StripeOnboardingRefresh() {
  const navigate = useNavigate();
  const { businessId } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      try {
        if (!businessId) return;
        const link = await businessOnboardingApi.getStripeOnboardingLink(businessId);
        const onboardingUrl = link?.data?.onboardingUrl;
        if (!onboardingUrl) throw new Error('Missing Stripe onboarding URL');
        window.location.assign(onboardingUrl);
      } catch (e) {
        if (!mounted) return;
        setError(e?.response?.data?.message || e?.message || 'Failed to restart Stripe onboarding');
        setTimeout(() => {
          navigate(`/business-admin?business_id=${businessId}`, { replace: true });
        }, 1200);
      }
    };

    run();
    return () => {
      mounted = false;
    };
  }, [businessId, navigate]);

  return (
    <div className="tailwind">
      <div className="flex min-h-[60dvh] w-full flex-col items-center justify-center gap-3 bg-gray-50 px-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-indigo-600" />
        <div className="text-sm text-gray-700">Re-opening Stripe onboarding…</div>
        {error && <div className="text-xs text-red-700">{error}</div>}
      </div>
    </div>
  );
}
